module.exports = __webpack_public_path__ + "media/images/tutorial_body_pc2-01-a3ee998e3aa108320280b2a7cad41ed6.png";